import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useController } from '@/hooks/useController';
import { hasUnreadMessagesSelector, isWidgetOpenState } from '@/state/session';
export const useUnreadMessagesNotify = () => {
    const hasUnreadMessages = useRecoilValue(hasUnreadMessagesSelector);
    const isOpen = useRecoilValue(isWidgetOpenState);
    const { notifyUnreadMessages } = useController();
    useEffect(() => {
        if (!isOpen && hasUnreadMessages) {
            notifyUnreadMessages();
        }
    }, [hasUnreadMessages, isOpen, notifyUnreadMessages]);
};
